// Etiquetas con código QR para pegar en cada equipo (una por unidad con serie
// y una por equipo a granel). Se imprimen desde el navegador.
import QRCode from 'qrcode';
import { el, clear } from '../../utils/dom.js';
import { Items, ItemUnits, Categories } from '../../api/resources.js';

export default async function EtiquetasPage(outlet, ctx) {
  clear(outlet);
  const cat = ctx.query?.categoria || '';
  let items = [];
  let units = [];
  let cats = [];
  try {
    [items, units, cats] = await Promise.all([
      Items.list({ limit: 1000 }).then((r) => r.data || []),
      ItemUnits.list({ limit: 1000 }).then((r) => r.data || []),
      Categories.list({ limit: 500 }).then((r) => r.data || []),
    ]);
  } catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  const delCat = (i) => !cat || i.category_id === cat;
  const etiquetas = [];
  for (const i of items.filter(delCat)) {
    if (i.es_kit) continue; // un combo no se etiqueta: se etiquetan sus equipos
    if (i.kind === 'bulk') { if (i.qr_code) etiquetas.push({ codigo: i.qr_code, nombre: i.name, detalle: 'A granel' }); }
    else {
      for (const u of units.filter((x) => x.item_id === i.id && x.qr_code)) {
        etiquetas.push({ codigo: u.qr_code, nombre: i.name, detalle: u.serial_number ? `S/N ${u.serial_number}` : (u.internal_code || '') });
      }
    }
  }

  const sel = el('select', { class: 'select', 'aria-label': 'Categoría', onchange: (e) => { location.hash = `#/etiquetas${e.target.value ? `?categoria=${e.target.value}` : ''}`; } },
    el('option', { value: '' }, 'Todas las categorías'),
    ...cats.map((c) => { const o = el('option', { value: c.id }, c.name); if (c.id === cat) o.selected = true; return o; }));

  outlet.appendChild(el('div', { class: 'page-head no-print' },
    el('div', {}, el('h1', {}, 'Etiquetas QR'), el('div', { class: 'muted' }, `${etiquetas.length} etiqueta${etiquetas.length === 1 ? '' : 's'}. Pégalas en cada equipo para escanearlos al preparar, entregar y recibir.`)),
    el('div', { class: 'flex gap-2 wrap' }, sel, el('button', { class: 'btn primary', onclick: () => window.print() }, 'Imprimir'))));

  const grid = el('div', { class: 'qr-grid' });
  outlet.appendChild(grid);
  for (const e of etiquetas) {
    const svg = await QRCode.toString(e.codigo, { type: 'svg', margin: 1, errorCorrectionLevel: 'M' });
    grid.appendChild(el('div', { class: 'qr-eti' },
      el('div', { class: 'qr-img', html: svg }),
      el('div', { class: 'qr-txt' }, el('strong', {}, e.nombre), el('span', {}, e.detalle), el('code', {}, e.codigo))));
  }
  if (!etiquetas.length) grid.appendChild(el('p', { class: 'muted' }, 'No hay equipos en esa categoría.'));
}
